import { Box, Typography } from '@mui/material'
import React from 'react'
import { BISubHeaders } from '../../@signals'


export default function acrissProvidersHeaders(header) {


    return {
        setHeaderCellProps: () => ({ sx:{ p: 0, borderBottom: 0, minWidth: 260, backgroundColor: 'primary.main' } }),
        render: () => <Box key={`${header}-${BISubHeaders.value.join("-")}`} sx={{ width: '100%'}}>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-around',
                flexDirection: 'column',
                gap: 1,
                backgroundColor: 'primary.main',
                pt: 1,
            }}>
                <Typography sx={{ fontWeight: 'bold' }} >{header}</Typography>
                <Box sx={{ backgroundColor: 'primary.dark', color: 'secondary.contrastText', px: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-around', width: '100%' }}>
                    {BISubHeaders.value.map((subHeader, idx) =><Box key={`${header}-${subHeader}-${idx}`} sx={{ minWidth: '120px' }}>
                        <Typography sx={{ fontWeight: 'bold' }} >{subHeader}</Typography>
                    </Box>)}
                </Box>
            </Box>
        </Box>
    }
}